import { Grid } from "@mui/material"
import React, { useEffect } from "react"
import NormalSteps from "./NormalSteps"
import SignatureDishes from "./SignatureDishes"
import HoursOfOperation from "./HoursOfOperation"
import { useDispatch } from "react-redux"
import { hotelAction } from "redux/hotel/slice/user"

const AddNewRestaurant = ({
  data,
  formik,
  activeStep,
  setActiveStep,
  type,
  setInitialFormValue,
  isRestaurant = false,
  open = false
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    formik.resetForm()
    dispatch(hotelAction.resetImageIds())
    dispatch(hotelAction.resetSignatureDishImages())
    dispatch(hotelAction.setCategoryImageId(""))
    setActiveStep(0)
  }, [open])

  return (
    <Grid container item xs={12} spacing={2} px={2}>
      <React.Fragment>
        {activeStep == 2 ? (
          <SignatureDishes
            data={data}
            type={type}
            formik={formik}
            setInitialFormValue={setInitialFormValue}
          />
        ) : activeStep == 1 ? (
          <HoursOfOperation
            data={data}
            type={type}
            formik={formik}
            setInitialFormValue={setInitialFormValue}
          />
        ) : (
          <NormalSteps
            data={data}
            type={type}
            formik={formik}
            isRestaurant={isRestaurant}
            activeStep={activeStep}
          />
        )}
      </React.Fragment>
    </Grid>
  )
}

export default AddNewRestaurant
